import React from 'react'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react'
import { HBox, Label, SVG, Tappable, VBox } from '~/ui/components'
import { createUseStyles, layout } from '~/ui/styling'
import ChannelHeader from './ChannelHeader'
import { useChat } from './ChatContext'

export interface Props {
  onCollapse?: () => void
}

const ChatHeader = observer((props: Props) => {

  const {onCollapse} = props

  const {service: {currentChat}} = useChat()

  const [t] = useTranslation('chat')

  //------
  // Rendering

  const $ = useStyles()

  function render() {
    return (
      <VBox classNames={$.ChatHeader}>
        {currentChat == null ? (
          renderDefaultHeader()
        ) : (
          <ChannelHeader
            backend={currentChat}
            onCollapse={onCollapse}
          />
        )}
      </VBox>
    )
  }

  function renderDefaultHeader() {
    return (
      <Tappable
        classNames={[$.defaultHeader, onCollapse != null && $.collapsible]}
        onTap={onCollapse}
        enabled={onCollapse != null}
      >
        <HBox gap={layout.padding.inline.m} align='middle' flex>
          {onCollapse != null && (
            <SVG
              name='chat'
              size={layout.icon.l}
            />
          )}
          <Label bold flex>
            {t('title')}
          </Label>
          {onCollapse != null && (
            <SVG
              name='chat-close'
              size={layout.icon.l}
              primary
            />
          )}
        </HBox>
      </Tappable>
    )
  }

  return render()

})

export default ChatHeader

export const height = layout.barHeight.l

const useStyles = createUseStyles(theme => ({
  ChatHeader: {
    borderBottom: [2, 'solid', theme.border.dimmer],
  },

  defaultHeader: {
    height,
    padding: [
      layout.padding.inline.m,
      layout.padding.inline.l,
    ],
  },

  collapsible: {
    cursor: 'pointer',
  },
}))